const commonThemeVariables = {
  colors: {
    danger: "#ff4d4f",
    primary: "#1890ff",
    base: "#f4f5f6",
    disabled: "#BDBDBD",
    white: "#fff",
    border: "#E2E2E2",
    black: "rgba(0, 0, 0, 0.65)",
    light_green: "#C8E6C9",
    light_blue: "#BBDEFB",
    light_gray: "#E0E0E0",
    light_yellow: "#FFF59D",
    light_red: "#EF9A9A",
  },

  space: [0, 8, 12, 24, 32, 40, 48, 64, 128, 256],
  font_size_xl: 20,
  font_size_md: 14,
  font_size_sm: 12,
  spacing_md: 12,
  spacing_sm: 8,
  spacing_xs: 4,
  spacing_lg: 18,
  spacing_xl: 32,
};

export default commonThemeVariables;
